import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["maximized", "onToggleMaximize", "onClose", "onClear", "canClear", "closeIconComponent", "minimizeIconComponent", "maximizeIconComponent", "titleIconComponent", "classNames", "translations"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cx } from "../../lib/index.js";
import { createButtonComponent } from "../Button.js";
import { SparklesIconComponent, MaximizeIconComponent as MaximizeIconComponentDefault, MinimizeIconComponent as MinimizeIconComponentDefault, CloseIconComponent as CloseIconComponentDefault } from "./icons.js";
export function createChatHeaderComponent(_ref) {
  var createElement = _ref.createElement;
  var Button = createButtonComponent({
    createElement: createElement
  });
  return function ChatHeader(_ref2) {
    var _ref2$maximized = _ref2.maximized,
      maximized = _ref2$maximized === void 0 ? false : _ref2$maximized,
      onToggleMaximize = _ref2.onToggleMaximize,
      onClose = _ref2.onClose,
      onClear = _ref2.onClear,
      _ref2$canClear = _ref2.canClear,
      canClear = _ref2$canClear === void 0 ? false : _ref2$canClear,
      CloseIconComponent = _ref2.closeIconComponent,
      MinimizeIconComponent = _ref2.minimizeIconComponent,
      MaximizeIconComponent = _ref2.maximizeIconComponent,
      TitleIconComponent = _ref2.titleIconComponent,
      _ref2$classNames = _ref2.classNames,
      classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames,
      userTranslations = _ref2.translations,
      props = _objectWithoutProperties(_ref2, _excluded);
    var translations = _objectSpread({
      title: 'Chat',
      minimizeLabel: 'Minimize chat',
      maximizeLabel: 'Maximize chat',
      closeLabel: 'Close chat',
      clearLabel: 'Clear'
    }, userTranslations);
    var defaultMaximizeIcon = maximized ? createElement(MinimizeIconComponentDefault, {
      createElement: createElement
    }) : createElement(MaximizeIconComponentDefault, {
      createElement: createElement
    });
    return createElement("div", _extends({
      className: cx('ais-ChatHeader', classNames.root, props.className)
    }, props), createElement("span", {
      className: cx('ais-ChatHeader-title', classNames.title)
    }, createElement("span", {
      className: cx('ais-ChatHeader-titleIcon', classNames.titleIcon)
    }, TitleIconComponent ? createElement(TitleIconComponent, null) : createElement(SparklesIconComponent, {
      createElement: createElement,
      width: 20,
      height: 20
    })), translations.title), createElement("div", {
      className: cx('ais-ChatHeader-actions')
    }, onClear && createElement(Button, {
      variant: "ghost",
      size: "sm",
      className: cx('ais-ChatHeader-clear', classNames.clear),
      onClick: onClear,
      disabled: !canClear
    }, translations.clearLabel), createElement(Button, {
      variant: "ghost",
      size: "sm",
      iconOnly: true,
      className: cx('ais-ChatHeader-maximize', classNames.maximize),
      onClick: onToggleMaximize,
      "aria-label": maximized ? translations.minimizeLabel : translations.maximizeLabel
    }, MaximizeIconComponent ? createElement(MaximizeIconComponent, {
      maximized: maximized
    }) : defaultMaximizeIcon), createElement(Button, {
      variant: "ghost",
      size: "sm",
      iconOnly: true,
      className: cx('ais-ChatHeader-close', classNames.close),
      onClick: onClose,
      "aria-label": translations.closeLabel,
      title: translations.closeLabel
    }, CloseIconComponent ? createElement(CloseIconComponent, null) : createElement(CloseIconComponentDefault, {
      createElement: createElement
    }))));
  };
}